import store from '@/store/index.js'
import { makeRequest } from '@/libs/RequestModule'

const sendEmail = async (subject, recipient = null, schoolAdminEmail = false, htmlFunction, functionParams) => {
    const { DSEMAILCONS } = store.getters.getCurrDependent
    const email = recipient || DSEMAILCONS // email de quem vai receber
    const response = (await makeRequest('sendEmail', { email, subject, schoolAdminEmail, htmlFunction, functionParams }))?.data
    return response
}

export { sendEmail }
